var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main" },
            [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c("el-col", { attrs: { span: 20 } }, [
                          _c(
                            "div",
                            { staticClass: "tag" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "padding-right": "20px" },
                                      attrs: { span: 4 }
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "label",
                                          attrs: {
                                            type: "success",
                                            effect: "light"
                                          }
                                        },
                                        [_vm._v("风格")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "tag_main",
                                      attrs: { span: 20 }
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          class: "all_item",
                                          attrs: {
                                            type:
                                              -1 == _vm.styleCur
                                                ? "success"
                                                : "info",
                                            effect: "light"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeStyle(-1)
                                            }
                                          }
                                        },
                                        [_vm._v("全部")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.styleData, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "style" + index,
                                            attrs: {
                                              type:
                                                index == _vm.styleCur
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.changeStyle(index)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.style_type))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "padding-right": "20px" },
                                      attrs: { span: 4 }
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "label",
                                          attrs: {
                                            type: "success",
                                            effect: "light"
                                          }
                                        },
                                        [_vm._v("空间类型")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "tag_main",
                                      attrs: { span: 20 }
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          class: "all_item",
                                          attrs: {
                                            type:
                                              -1 == _vm.spaceCur
                                                ? "success"
                                                : "info",
                                            effect: "light"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeSpace(-1)
                                            }
                                          }
                                        },
                                        [_vm._v("全部")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.spaceData, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "space" + index,
                                            attrs: {
                                              type:
                                                index == _vm.spaceCur
                                                  ? "success"
                                                  : "info",
                                              effect: "light"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.changeSpace(index)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.space_type))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-right",
                                  type: "success"
                                },
                                on: { click: _vm.toNew }
                              },
                              [
                                _c("span", { staticClass: "btn" }, [
                                  _vm._v("上传新素材")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadType,
                        expression: "loadType"
                      },
                      {
                        name: "infinite-scroll",
                        rawName: "v-infinite-scroll",
                        value: _vm.getMeterial,
                        expression: "getMeterial"
                      }
                    ],
                    ref: "listBox",
                    staticClass: "list_box"
                  },
                  [
                    _c(
                      "waterfall",
                      {
                        attrs: {
                          col: 5,
                          gutterWidth: 20,
                          data: _vm.meterialData,
                          lazyDistance: 200
                        },
                        on: { finish: _vm.loadFinish }
                      },
                      [
                        _vm._l(_vm.meterialData, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: "meterial" + index,
                              staticClass: "item",
                              on: {
                                click: function($event) {
                                  return _vm.toDetail(index)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.photo_url +
                                    "?x-oss-process=image/resize,w_300",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.meterialData.length <= 0
                      ? _c(
                          "div",
                          { staticClass: "list" },
                          [
                            _c("el-empty", {
                              attrs: { description: "暂无数据" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        width: "60%",
                        "show-close": true,
                        center: "",
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "img" }, [
                        _vm.dialogCur != -1
                          ? _c("img", {
                              attrs: { src: _vm.detailImg, alt: "" }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toGenerate(_vm.dialogCur)
                                }
                              }
                            },
                            [_vm._v("生成同款")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.toDelete(_vm.dialogCur)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-delete" }),
                              _vm._v(" 删除")
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "new"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        top: "10vh",
                        width: "60%",
                        "show-close": true,
                        center: "",
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c("h3", [_vm._v("上传新素材")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "upload_box" },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                multiple: "",
                                "http-request": _vm.uploadImage
                              }
                            },
                            [
                              _vm.uploadImg
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.uploadImg }
                                  })
                                : _c("el-button", {
                                    attrs: { icon: "el-icon-plus" }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pop_tag_box" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("风格")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 22 } },
                                [
                                  _vm._l(_vm.styleData, function(item, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: item.style_type,
                                        attrs: {
                                          closable: item.material_style_id != 0,
                                          "disable-transitions": false,
                                          effect:
                                            _vm.uploadStyleCur == index
                                              ? "dark"
                                              : "plain",
                                          type: "success"
                                        },
                                        on: {
                                          close: function($event) {
                                            return _vm.handleClose(index)
                                          },
                                          click: function($event) {
                                            return _vm.uploadStyleClick(index)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.style_type) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.inputStyleVisible
                                    ? _c("el-input", {
                                        ref: "saveStyleTagInput",
                                        staticClass: "input-new-tag",
                                        attrs: { size: "small" },
                                        on: { blur: _vm.handleInputConfirm },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleInputConfirm.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.inputStyleValue,
                                          callback: function($$v) {
                                            _vm.inputStyleValue = $$v
                                          },
                                          expression: "inputStyleValue"
                                        }
                                      })
                                    : _c(
                                        "el-button",
                                        {
                                          staticClass: "button-new-tag",
                                          attrs: { size: "small" },
                                          on: { click: _vm.showStyleInput }
                                        },
                                        [_vm._v("+ new")]
                                      )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pop_tag_box" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("空间")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 22 } },
                                [
                                  _vm._l(_vm.spaceData, function(item, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: item.space_type,
                                        attrs: {
                                          closable: item.material_space_id != 0,
                                          "disable-transitions": false,
                                          effect:
                                            _vm.uploadSpaceCur == index
                                              ? "dark"
                                              : "plain",
                                          type: "success"
                                        },
                                        on: {
                                          close: function($event) {
                                            return _vm.handleSpaceClose(index)
                                          },
                                          click: function($event) {
                                            return _vm.uploadSpaceClick(index)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.space_type) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.inputSpaceVisible
                                    ? _c("el-input", {
                                        ref: "saveSpaceTagInput",
                                        staticClass: "input-new-tag",
                                        attrs: { size: "small" },
                                        on: {
                                          blur: _vm.handleInputSpaceConfirm
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleInputSpaceConfirm.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.inputSpaceValue,
                                          callback: function($$v) {
                                            _vm.inputSpaceValue = $$v
                                          },
                                          expression: "inputSpaceValue"
                                        }
                                      })
                                    : _c(
                                        "el-button",
                                        {
                                          staticClass: "button-new-tag",
                                          attrs: { size: "small" },
                                          on: { click: _vm.showSpaceInput }
                                        },
                                        [_vm._v("+ new")]
                                      )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c("el-button", { on: { click: _vm.toCancel } }, [
                            _vm._v("取消")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.toSave }
                            },
                            [_vm._v("开始上传")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee02c8da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee02c8da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Material/Person.vue
// module id = null
// module chunks = 